// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronDownSmallIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ChevronDownSmallIcon" ref={forwardedRef} {...props}>
      <path d="M5.757 8.485 10 12.728l4.243-4.243-1.061-1.06L10 10.607 6.818 7.425z" />
    </SvgIcon>
  );
});

/**
 * Indicates an expandable/expanded component such as a dropdown or tree navigation
 * @public
 */
export const ChevronDownSmallIcon = /* @__PURE__ */ Object.assign(
  ChevronDownSmallIconComponent,
  { displayName: 'ChevronDownSmallIcon' },
);
